export interface CountToOptions {
  from: number | string;
  to: number | string;
  refreshInterval: number | string;
  speed: number | string;
}

export default (element: HTMLElement, options: CountToOptions) => {
  if (!element) throw new Error("countto: element is required");

  const $elem = $(element);
  $elem.appear(() =>
    $elem.countTo({
      from: +options.from,
      to: +options.to,
      refreshInterval: +options.refreshInterval,
      speed: +options.speed
    })
  );
};
